import request from "../utils/request";

//获取微信分享config内容信息
export function queryWeiXinAppId(data, headers) {
  return request({
    url: "/api-c/v1/community/wx/getJsSdkConf?url=" + data.url,
    method: "GET",
    headers,
  });
}
